/**
 * Клиент кеша запросов с настройками приложения. Рабочий и учебный контуры получают
 * отдельные экземпляры: учебные данные и рабочий кеш физически не пересекаются (E4.5).
 *
 * Результат мутации показывается одним общим уведомлением (meta мутации -- mutationMeta.ts):
 * отказ -- если мутация не объявила silentError, успех -- если задан successMessage.
 */

import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiError, endsSession } from '@/api/client';
import i18n from '@/utils/i18n';
import { failureMessage, messageText } from '@/utils/displayMessage';

export function createQueryClient(): QueryClient {
	return new QueryClient({
		mutationCache: new MutationCache({
			onError: (error, _variables, _context, mutation) => {
				if (mutation.options.meta?.silentError) return;
				/* Сессию закончила сама ошибка: об этом говорит окно входа или выход */
				if (endsSession(error)) return;
				/* Ошибка не от сервера (обрыв сети, сбой разбора): деталь только в консоль */
				if (!(error instanceof ApiError)) console.error('Mutation failed:', error);
				toast.error(messageText(i18n.t, failureMessage(error)));
			},
			onSuccess: (_data, _variables, _context, mutation) => {
				const message = mutation.options.meta?.successMessage;
				if (message) toast.success(messageText(i18n.t, message));
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: 5 * 60 * 1000,
				retry: 1,
				refetchOnWindowFocus: false,
			},
		},
	});
}
